<template>
    <div class="loading-container">
        <div v-if="loaded"><slot/></div>
        <div v-else class="text-center mt-3">
            <b-spinner variant="primary"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props: {data: Array},
        data() {
            return {
                loaded: false
            }
        },
        watch: {
            data(val) {
                let loaded = true
                val.forEach((item) => {
                    if (item == null)
                        loaded = false
                })
                this.loaded = loaded
            }
        }
    }
</script>

<style scoped>

</style>
